import { Dictionary } from "../../../entities/common";
import OKRImage from "../../../../src/images/sections/okr.png";
import BudgetImage from "../../../../src/images/sections/budget.png";
import BenefitsImage from "../../../../src/images/sections/benefits.svg";
import TimeImage from "../../../../src/images/sections/time.png";
import DecisionMatrixImage from "../../../../src/images/sections/decision-matrix.png";
import StrategicAlignmentImage from "../../../../src/images/sections/strategic-alignment.png";
import ResourcePlanImage from "../../../../src/images/sections/resource-plan.png";
import UtilizationImage from "../../../../src/images/sections/utilization.png";
import WorkWeekImage from "../../../../src/images/sections/work-week.png";
import WorkloadImage from "../../../../src/images/sections/workload.png";
import CalendarExceptionsImage from "../../../../src/images/sections/calendar-exceptions.png";
import RoadmapImage from "../../../../src/images/sections/roadmap.png";
import EmbeddedContentImage from "../../../../src/images/sections/embedded-content.svg";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { CommonOperations, contains } from "../../../store/permissions";
import { History } from "history";
import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import { UserState } from "../../../store/User";

type InaccessibleSectionSettings = {
    image: string;
    description?: string;
    onRenderButtons?: (permissions: CommonOperations, history: History) => JSX.Element;
};

const defaultSectionDescription =
    "This section is not accessible for viewing as it is not included in your current subscription plan.\
    To gain access to this section, please upgrade your plan.";

const inaccessibleSectionImageMap: Dictionary<InaccessibleSectionSettings> = {
    ["OKR"]: { image: OKRImage },
    ["Budget"]: { image: BudgetImage },
    ["Benefits"]: { image: BenefitsImage },
    ["Time"]: { image: TimeImage },
    ["Decision Matrix"]: { image: DecisionMatrixImage },
    ["Strategic Alignment"]: { image: StrategicAlignmentImage },
    ["Resource plan"]: { image: ResourcePlanImage },
    ["Utilization"]: { image: UtilizationImage },
    ["Calendar"]: { image: WorkWeekImage },
    ["Workload"]: { image: WorkloadImage },
    ["Calendar Exceptions"]: { image: CalendarExceptionsImage },
    ["Roadmap"]: { image: RoadmapImage },
    ["Embedded Content"]: { image: EmbeddedContentImage },
};

type Props = {
    sectionName: string;
};

type OwnProps = {
    user: UserState;
};

const InaccessibleSection = (props: Props & OwnProps & RouteComponentProps<{}>) => {
    const { sectionName, history } = props;
    const permissions = props.user.permissions.common;
    return (
        <div className="inaccessible-section">
            <img src={inaccessibleSectionImageMap[sectionName].image} alt={sectionName} />
            <div className="description">{inaccessibleSectionImageMap[sectionName].description ?? defaultSectionDescription}</div>
            <div className="buttons">
                {inaccessibleSectionImageMap[sectionName].onRenderButtons ? (
                    inaccessibleSectionImageMap[sectionName].onRenderButtons!(permissions, history)
                ) : (
                    <>
                        {contains(permissions, CommonOperations.BillingManage) && <PrimaryButton className="upgrade-plan" onClick={() => history.push("/billing")} key="upgrade-plan" text="Upgrade Plan" />}
                        <DefaultButton
                            href="https://help.ppm.express/99995-ppm-express-subscription-plans-and-licensing/ppm-express-subscription-plans"
                            target="_blank"
                            key="learn-more"
                            text="Learn more"
                        />
                    </>
                )}
            </div>
        </div>
    );
};

function mapStateToProps(state: ApplicationState, ownProp: OwnProps) {
    return {
        user: state.user
    };
}

export default withRouter<Props>(connect(mapStateToProps)(InaccessibleSection));
